import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, mergeMap, switchMap, tap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../../../../src/app/core/services/network-call.service';
import { PermissionService } from '../../../core/services/permission.service';
import { SessionStorageIds } from '../../../shared/enums';
import * as logout from '../actions/logout.actions';
import { ILogoutRequest } from '../models/logout.model';

@Injectable()
export class LogoutEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private permissionService: PermissionService
  ) {}

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout.loadLogoutRequest),
      switchMap(action =>
        this.networkCallService.post<ILogoutRequest, string>('Authentication/logout', action.request).pipe(
          mergeMap(response => {
            sessionStorage.clear();
            this.router.navigateByUrl('auth/sign-up');
            return [logout.loadLogoutSuccess({ response }), logout.clearStore()];
          }),
          retryTransientHttpErrors(),
          catchError(error => {
            return of(logout.loadLogoutFailure(error));
          })
        )
      )
    )
  );

  clearPermissionsOnLogout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logout.clearStore),
        tap(() => {
          sessionStorage.removeItem(SessionStorageIds.AUTH_PERMISSIONS);
          sessionStorage.removeItem(SessionStorageIds.AUTH_LEGAL_ENTITY_PERMISSIONS);
          sessionStorage.removeItem(SessionStorageIds.PERMISSIONS);
          this.permissionService.refreshFromSession();
        })
      ),
    { dispatch: false }
  );
}
